import Chip from "@mui/material/Chip";
import clsx from "clsx";
import { useEnvContext } from "context/EnvContext";
import { ENV_PRODUCTION } from "core/model/config";
import { activateEnvSwitch } from "core/model/utils/featureFlags";
import { GREY_300 } from "ds_legacy/materials/colors";

export default function BlinkingEnv() {
  const { env } = useEnvContext();

  if (!activateEnvSwitch) return null;

  return (
    <div
      className={clsx("flex flex-grow items-center", {
        "animate-pulse": env === ENV_PRODUCTION,
      })}
    >
      <Chip label={env} sx={{ background: GREY_300 }} />
    </div>
  );
}
